/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "@/plugins";
import vuetify from "@/plugins/vuetify";
import axios from "axios";
import VueSocketIO from "vue-socket.io";
import { socketIO } from "@/constant/config";
import VueSessionStorage from "vue-sessionstorage";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue2Filters from "vue2-filters";
import Notifications from "vue-notification";
import BootstrapVue from 'bootstrap-vue'
import vueDebounce from 'vue-debounce';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "@/filter";
import 'vuetify/dist/vuetify.min.css';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import '@/assets/responsive/font.scss'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VueDragscroll from 'vue-dragscroll';
import VueAuthImage from 'vue-auth-image';
import locale from 'element-ui/lib/locale/lang/en';
import Print from 'vue-print-nb';
import langApp from '@/constant/lang/en';
import authApi from "@/api/auth";
import VueCookies from 'vue-cookies'
import Paginate from 'vuejs-paginate'
import VueLazyload from 'vue-lazyload'
import VueMatomo from 'vue-matomo';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VClamp from 'vue-clamp'
//import Tawk from 'vue-tawk'

// Vue.use(Tawk, {
//     tawkSrc: 'https://embed.tawk.to/609b7866b1d5182476b81baa/1f5fksksj'
// })
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'dist/error.png',
    loading: 'dist/loading.gif',
    attempt: 1
})
Vue.use(VueCookies)
Vue.use(langApp);
Vue.use(VueAuthImage);
//library.add(faUserSecret);
Vue.use(ElementUI, { locale });
Vue.use(Print);
Vue.use(vueDebounce);
Vue.use(BootstrapVue);
Vue.use(VueSessionStorage);
Vue.use(Vue2Filters);
Vue.use(Notifications);
Vue.component('paginate', Paginate);
Vue.component('v-clamp', VClamp);
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);
Vue.use(VueDragscroll);
Vue.config.ignoredElements = ['ion-icon']
// load a locale

numeral.locale('en');
Vue.filter('numFormat', numFormat(numeral));
const controller = new AbortController()
window.$abortController = controller
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;
axios.defaults.signal = window.$abortController.signal
axios.interceptors.request.use(
    function (config) {
        config.signal = window.$abortController.signal
        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);

if(window.matomoEnabled){
    Vue.use(VueMatomo, {
        host: 'https://matomo.myrender.vn',
        siteId: 4,
        trackerFileName: 'matomo',
        router: router,
        enableLinkTracking: true,
        requireConsent: false,
        trackInitialView: true,
        disableCookies: false,
        requireCookieConsent: false,
        enableHeartBeatTimer: false,
        heartBeatTimerInterval: 15,
        debug: false,
        userId: null,
        trackSiteSearch: false
    });
}

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error && error.response && error.response.status && error.response.status === 401) {
        console.error("login-err", error);
        authApi.proccessingLogout();
        window.location = '/login';
    }
    return error;
});

// const socket = io(socketIO.url);
// Vue.use(VueSocketIOExt, socket, { store });
Vue.use(
    new VueSocketIO({
        debug: false,
        connection: socketIO.url,
        options: {
            reconnection: true,
            reconnectionDelay: 500,
            autoConnect: true,
        },
        vuex: {
            store,
            // actionPrefix: "SOCKET_",
            // mutationPrefix: "SOCKET_"
        }
    })
);

// or with options
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '/static/image/irender-placeholder.svg',
    loading: '/static/image/irender-placeholder.svg',
    attempt: 1
});

String.prototype.format = function () {
    var a = this;
    for (var k in arguments) {
        a = a.replace(new RegExp("\\{" + k + "\\}", 'g'), arguments[k]);
    }
    return a
}

Vue.prototype.axiosController = controller
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

const iRenderApp = new Vue({
    router,
    store,
    vuetify,
    data(){        
        return {
            isDialogExpiredShowing: false,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            breakpoint: 'xs',
            $controller: controller,
        }
    },
    mounted() {
        let cookies = Vue.$cookies.get(process.env.VUE_APP_COOKIE_NAME);
        let checkCookies = (cookies && cookies !== null && cookies !== '');
        if (checkCookies) this.$getParameterCommon();
        setInterval(() => {
            this.$socket.connect();
        }, 5000);
        this.$nextTick(() => {
            this.onResize()
            window.addEventListener('resize', this.onResize)
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            Vue.set(this, 'windowHeight', window.innerHeight)
            Vue.set(this, 'windowWidth', window.innerWidth)
            Vue.set(this, 'breakpoint', this.getBreakpoint())
        },
        getBreakpoint() {
            if (this.windowWidth >= 1400) return 'xxl'
            if (this.windowWidth >= 1200) return 'xl'
            if (this.windowWidth >= 992) return 'lg'
            if (this.windowWidth >= 768) return 'md'
            if (this.windowWidth >= 576) return 'sm'
            return 'xs'
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
    render: h => h(App)
}).$mount("#app");

export const bus = new Vue();
//console.log("process.env.NODE_ENV", process.env.NODE_ENV);
//var element = document.createElement("script");